import { Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'
import { ALL_ARTICLES, formatDate } from '../lib/articles.js'

/*
 * Read-only pipeline view of every article — live, scheduled, and draft. Articles
 * are file-based (src/content/articles/*.md), so this page shows status but doesn't
 * edit: publishing/editing happens in the files + a deploy. It exists so you can
 * see what's queued and when each piece goes live.
 */
const STATUS = {
  live: { label: 'Live', cls: 'green' },
  scheduled: { label: 'Scheduled', cls: 'blue' },
  draft: { label: 'Draft', cls: '' },
}

export default function AdminArticles() {
  const counts = ALL_ARTICLES.reduce((m, a) => ({ ...m, [a.status]: (m[a.status] || 0) + 1 }), {})

  return (
    <main className="page">
      <Seo title="Articles — Admin | CalculateMyPeptides" noindex />
      <div className="container page-narrow">
        <Link to="/admin" className="pep-back">← Site Admin</Link>
        <div className="between wrap" style={{ marginBottom: 6 }}>
          <div>
            <h1 className="section-title">Articles</h1>
            <p className="section-sub mb-0">
              Every article and its schedule. {counts.live || 0} live · {counts.scheduled || 0} scheduled · {counts.draft || 0} draft.
            </p>
          </div>
          <Link to="/articles" className="btn btn-soft btn-sm">View live blog ↗</Link>
        </div>

        <div className="config-notice" style={{ margin: '14px 0 18px' }}>
          <strong>File-based & scheduled.</strong>
          <p style={{ marginBottom: 0 }}>
            Articles live in <code>src/content/articles/</code>. A scheduled piece publishes itself on its date via the
            daily rebuild cron. To add, edit, or reschedule one, change the file and deploy — see <code>ARTICLES.md</code>.
          </p>
        </div>

        {ALL_ARTICLES.length === 0 ? (
          <div className="card empty"><div className="emoji">📝</div><h3>No articles yet</h3></div>
        ) : (
          <div className="admin-list">
            {ALL_ARTICLES.map((a) => {
              const s = STATUS[a.status] || STATUS.draft
              return (
                <div className="card admin-row" key={a.slug}>
                  <div style={{ minWidth: 0 }}>
                    <div className="row" style={{ gap: 8, marginBottom: 4 }}>
                      <span className={`pill ${s.cls}`}>{s.label}</span>
                      <span className="muted small">
                        {a.status === 'scheduled' ? `publishes ${formatDate(a.publishAt)}` : formatDate(a.date)}
                        {' · '}{a.readingMins} min
                      </span>
                    </div>
                    <div style={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.title}</div>
                    <div className="muted small" style={{ marginTop: 2 }}>/articles/{a.slug}</div>
                  </div>
                  <div className="row" style={{ gap: 6 }}>
                    <Link to={`/admin/articles/${a.slug}`} className="btn btn-ghost btn-sm">Review</Link>
                    {a.status === 'live' && <Link to={`/articles/${a.slug}`} className="btn btn-soft btn-sm">View live ↗</Link>}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </main>
  )
}
